
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M18 10a2 2 0 11.001 3.999A2 2 0 0118 10zm-4 2a2 2 0 10-3.999-.001A2 2 0 0014 12zm-6 0a2 2 0 10-3.999-.001A2 2 0 008 12z"}})])
          )
        }
      }
    